module.exports = __webpack_public_path__ + "img/new_kasin.5a7b6be2.png";